export default "__VITE_ASSET__4_nIwqO0__"